import React, { Component } from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../assets/js/constants';
import { FONTS } from '../../../tokens/fonts';

const RadioButtonNew = styled.label`
    display: block;
    box-sizing: border-box;
    position: relative;
    padding: 10px 0 8px 30px;
    cursor: pointer;
    ${FONTS.S};
    width: 100%;
    opacity: ${props => props.disabled ? 0.3 : 1};
`;

const Input = styled.input`
    position: absolute;
    opacity: 0;
    left: -9999px;
    height: 0;
    width: 0;
`;

const RadioButtonCheckmark = styled.span`
    position: absolute;
    height: 20px;
    width: 20px;
    top: calc(50% - 10px);
    left: 0;
    border: 1px solid ${COLORS.grey};
    border-radius: 50%;
    transition: all 0.1s ease;
    background: white;
    box-sizing: content-box;
    transition: 0.2s;
    ${RadioButtonNew}:hover ${Input}:not(:checked) ~ & {
        border-color: ${props => props.disabled ? '' : COLORS.darkGrey};
 };
    ${Input}:checked ~ & {
        border-color: ${COLORS.lightGreen};
        background-color: ${COLORS.lightGreen};
        &:after {
            content: "";
            position: absolute;
            width: 10px;
            height: 10px;
            top: 5px;
            left: 5px;
            border-radius: 50%;
            background-color: white;
        }
        &:hover {
            border-color: ${COLORS.green};
            background-color: ${COLORS.green};
        }
    }
`;

/**
 * @deprecated
 * Использовать новый компонент BaseRadio src/components/controls/baseRadio
 * */
export class RadioButton extends Component {
    render() {
        const { className, label, value, dataTest, disabled, ...rest } = this.props;
        return (
            <RadioButtonNew className={className} data-test={dataTest} disabled={disabled}>
                <Input type='radio' value={value} {...rest} disabled={disabled} />
                <RadioButtonCheckmark disabled={disabled}></RadioButtonCheckmark>
                {label || value}
            </RadioButtonNew>
        );
    }
}
